module.exports = __webpack_public_path__ + "static/media/partner-icon-taptools-greyscale.68e7311b.svg";